<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->

    <router-view></router-view>
  </div>
</template>

<script>
  // import header from './components/Header.vue';
  // import $ from 'jquery'
  export default {
    // 		name: 'App',
    // 		components: {
    // 			//NavMenu: NavMenu,
    // 			headerNav: header,
    // 		},
  created: function() {

    // window.addEventListener('beforeunload', () => {
    //  
    //   var c = this.$router.currentRoute.path
    //   console.log(c)
    //   // sessionStorage.setItem('_c_lastPath', this.$router.currentRoute.path)
    // })
  },
  
  // watch: {
  //   '$route': function(newUrl, oldUrl) {
  //    
  //     //this.$router.go(0);
  //     //this.appKey=new Date().getTime();
  //   }
  // },
    // 		mounted() {
    // 			//debugger
    // 			$(".el-menu-item").on("mouseenter", function(e) {
    // 				//debugger
    // 				//var cc=$(this).attr('data')
    // 				$(".a1").html("")
    // 				var img =
    // 					"<img src=' http://www.xiaoyezi.com/imgs/index_site/tap3.jpg' style='width: 290px; height: 250px;'>"
    // 				$(".a1").append(img);
    // 			})
    // 			this.init()
    //
    // 		},
    methods: {
      // _isMobile() {
      //   debugger
      //
      // },
      // 			init() {
      // 				//debugger
      // 				var c = $(".el-menu--popup")
      // 				var d = $(".el-menu--popup>div")
      // 				d.addClass("left")
      // 				var boarddiv =
      // 					"<div class='a1' style='float: left;'><img src='http://www.xiaoyezi.com/imgs/index_site/prolist6.png' style='width: 290px; height: 250px;'/></div>";
      // 				c.append(boarddiv);
      // 				//$(".el-menu-item").on("mouseleave",mouset)
      // 			},
      //

    },
    data() {
      return {

      }
    }
  }
</script>

<style>
  #app {
    /* 	font-family: 'Avenir', Helvetica, Arial, sans-serif; */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /* 	text-align: center; */
    color: #2c3e50;

    width: 100%;
    padding: 0px;
    margin: 0px;
    position: absolute;
    top: 0px;
    left: 0px;
    height: 100%;
    border: hidden;
  }

  /* 水平样式 */
  .el-menu--horizontal>div>.el-submenu {
    float: left;
  }

  /* 一级菜单的样式 */
  .el-menu--horizontal>div>.el-menu-item {
    float: left;
    height: 60px;
    line-height: 60px;
    margin: 0;
    border-bottom: 2px solid transparent;
    color: #909399;
  }

  .el-menu--horizontal>div>.el-submenu .el-submenu__icon-arrow {
    position: static;
    vertical-align: middle;
    margin-left: 8px;
    margin-top: -3px;
  }

  .left {
    float: left;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue